<template>
    <div id="form">
        <v-row justify="center">
            <v-col>
                <!-- заголовок -->
                <v-card-title>
                    Приоритеты
                    <v-spacer></v-spacer>
                    <v-text-field v-model="searchFilials" prepend-icon="mdi-cloud-search-outline"
                        :label="stringValues.search[currentLanguage.language]"></v-text-field>
                    <v-spacer></v-spacer>
                    <v-autocomplete 
                        :label="stringValues.priorityLines[currentLanguage.language]" 
                        item-text="name" 
                        item-value="number" 
                        :items="lines[currentLanguage.language].filter(element => element.filter == true)"
                        @change="GetFilialsByLine" 
                        persistent-hint 
                        hint="Выберите линию" 
                        clearable
                        v-model="filterLine"
                        return-object
                    ></v-autocomplete>
                </v-card-title>

                <v-sheet v-if="firstLoad" class="px-3 pt-3 pb-3">
                    <v-skeleton-loader class="mx-auto" type="table-thead"></v-skeleton-loader>
                    <v-skeleton-loader class="mx-auto" type="table-row-divider@5"></v-skeleton-loader>
                    <v-skeleton-loader class="mx-auto" type="table-tfoot"></v-skeleton-loader>
                </v-sheet>

                <v-card>
                    <v-form ref="listForm" lazy-validation>
                        <v-data-table 
                            :headers="filialHeaders[currentLanguage.language]" 
                            v-show="!firstLoad" 
                            :items="filials" 
                            :items-per-page="15"
                            class="elevation-2" 
                            :loading="loading"
                            :search="searchFilials"
                            >

                            <template v-slot:item.line ="{ item }">
                                <v-chip @click="EditFilialLine(item)"
                                    :color="`${item.color}`"
                                    outlined
                                >
                                    {{ lines[currentLanguage.language].find(({ number }) => number === item.line).name }}
                                </v-chip>
                            </template>

                            <template v-slot:item.maxOrderDetails="{ item }">
                                <span >
                                    <b>{{ item.maxOrderDetails != null ? item.maxOrderDetails : "нет"}}</b>
                                </span>
                                <v-edit-dialog
                                    :return-value.sync="item.maxOrderDetails"
                                    large
                                    lazy
                                    persistent
                                    @save="SaveQuantity(item)"
                                    :saveText="stringValues.save[currentLanguage.language]"
                                    :cancelText="stringValues.cancel[currentLanguage.language]"
                                >
                                    <div class="text-no-wrap">
                                        <v-icon small>mdi-pencil</v-icon>
                                    </div>
                                    <template v-slot:input>
                                        <v-text-field
                                            v-model="item.maxOrderDetails"
                                            single-line
                                            counter
                                            autofocus
                                            type="number"
                                            min="0"
                                            :rules="[quantityRules]"
                                            @input="onInputMaxOrder"
                                            label="Введите количество"
                                        ></v-text-field>
                                    </template>
                                </v-edit-dialog>
                            </template>
                        </v-data-table>
                    </v-form>
                </v-card>
            </v-col>
        </v-row>
        <!-- модальное окно -->
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">{{ formTitle }}</span>
                </v-card-title>
        
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field disabled v-model="editedItem.name" :label="stringValues.provider[currentLanguage.language]" ></v-text-field>
                            </v-col>
                            <v-select
                                v-model="editedItem.line"
                                prepend-icon="mdi-city-variant-outline"
                                :items="lines[currentLanguage.language]"
                                menu-props="auto"
                                :label="stringValues.line[currentLanguage.language]"
                                single-line
                                item-text="name"
                                item-value="number"
                            ></v-select>
                        </v-row>
                    </v-container>
                </v-card-text>
        
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                        {{ stringValues.cancel[currentLanguage.language] }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save" :disabled='isDisabled'>
                        Изменить
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    inject: ["theme"],
    data: () => ({
        quantityRules: (v) => (v > 0) || "не должно быть меньше 1",
        filterLine: null,
        formTitle: 'Изменить приоритет',
        dialog: false,
        filials: [],
        distributors: [],
        loading: false,
        firstLoad: true,
        searchFilials: "",
        filialHeaders: {
            "RU": [
                { text: "ID", sortable: true, value: "id", align: "center"},
                { text: "Поставщик", value: "name", align: "center" },
                { text: "Линия", sortable: false, value: "line", align: "center" },
                { text:"Позиции в заказе", sortable: false, value: "maxOrderDetails", align: "center" }
            ],
            "KZ": [
                { text: "ID", sortable: true, value: "id", align: "center"},
                { text: "Жеткізуші", value: "name", align: "center" },
                { text: "Желі", sortable: false, value: "line", align: "center" },
                { text:"Позиции в заказе", sortable: false, value: "maxOrderDetails", align: "center" }
            ],
        },
        editedItem: {
            name: "",
            line: { number: 4, name: "Не выбрана", color: "grey" }
        },
        lines: {
            "RU": [
                { number: -1, name: "Отключено", color: "red", filter: true },
                { number: 1, name: "Первая линия", color: "green", filter: true },
                { number: 2, name: "Вторая линия", color: "primary", filter: true },
                { number: 3, name: "Третья линия", color: "secondary", filter: true },
            ],
            "KZ": [
                { number: -1, name: "Отключено", color: "red", filter: true },
                { number: 1, name: "бірінші желі", color: "green", filter: true },
                { number: 2, name: "екінші желі", color: "primary", filter: true },
                { number: 3, name: "үшінші желі", color: "secondary", filter: true },
            ],
        },
        oldline: null,
        editFilialId: null,
    }),
    async mounted() {
        this.GetFilialLines();
    },
    methods: {
        onInputMaxOrder(value) {
            const num = Number(value);
            this.item.maxOrderDetails = isNaN(num) ? 0 : Math.max(0, num);
        },
        SaveQuantity(item) {
            let payload = {
                filialId: item.id,
                line: item.line,
                maxOrderDetails: item.maxOrderDetails
            };

            this.$store
                .dispatch("UPDATE_FILIAL_LINE", payload)
                .then(() => {
                    this.GetFilialLines();
                    this.dialog = false;
                })
                .catch(() => {
                    let Snackbar = {
                        text: "Произошла ошибка",
                        timeout: 3000,
                        color: "error",
                        show: true,
                    };
                    this.$store.commit("SET_SNACKBAR", Snackbar);
                })
        },
        GetFilialLines() {
            this.firstLoad = true;
            this.$store
                .dispatch("FILIAL_WITH_LINES_BY_CONTEXT")
                .then(() => {
                    this.firstLoad = false;
                    this.filials = this.$store.getters.FILIALS;

                    this.filials.forEach(element => {
                        element.line = element.filialLines[0]?.line ?? -1;
                        element.color = this.lines[this.currentLanguage.language].find(({ number }) => number === element.line).color;
                        element.maxOrderDetails = element.filialLines[0]?.maxOrderDetails;
                    });
                    this.GetFilialsByLine(this.filterLine)
                })
                .catch(() => {
                });  
        },
        async save() {
            if (this.editedItem.line === 0) {
                this.$store
                    .dispatch("DELETE_FILIAL_LINE", this.editedItem.filialLineId)
                    .then(() => {
                        this.GetFilialLines();
                        this.dialog = false;
                    })
                    .catch(() => {
                        let Snackbar = {
                            text: "Произошла ошибка",
                            timeout: 3000,
                            color: "error",
                            show: true,
                        };
                        this.$store.commit("SET_SNACKBAR", Snackbar);
                    })
            }
            else {

                const payload = {
                    filialId: this.editFilialId,
                    line: this.editedItem.line,
                    maxOrderDetails: this.filials.find(x => x.id === this.editFilialId).maxOrderDetails
                }

                try {
                        await this.$store.dispatch("UPDATE_FILIAL_LINE", payload);
                        this.GetFilialLines();
                        this.dialog = false;
                        this.$store.commit("SET_SNACKBAR", {
                            text: "Линия успешно обновлёна",
                            color: "success",
                            show: true
                        });
                    } catch (error) {
                        this.$store.commit("SET_SNACKBAR", {
                            text: "Ошибка обновления",
                            color: "error",
                            show: true
                        });
                    }   
            }
        },
        close() {
            this.dialog = false;  
        },
        EditFilialLine(value) {
            window.console.log(value)
            let newObject = Object.assign({}, value);
            this.editedItem.name = newObject.name;
            this.editedItem.line = newObject.line;
            this.editedItem.filialLineId = newObject.filialLines[0]?.id;

            this.editFilialId = newObject.id;
            this.oldline = newObject.line;
            this.dialog = true;
        },
        GetFilialsByLine(line) {
            if (line == null) {
                this.filials = this.$store.getters.FILIALS;
            }
            else {
                this.filials = this.$store.getters.FILIALS
                    .filter(element => element.line == line.number);
            }
        }, 
    },
    created() {           
        window.console.log(this.lines)
    },
    computed: {
        stringValues: {
            get() {
                return this.$store.getters.STRING_VALUES;
            },
        },
        currentLanguage: {
            get() {
                return this.$store.getters.CURRENT_LANG;
            }
        },
        isDisabled: {
            get() {
                return this.oldline == this.editedItem.line;
            },
        }
    }
};
</script>

<style >
</style>